import React from "react";
import { friendlyNumber, friendlyPrice } from "../../../utils/calculators";
import TableLayout from "../../layouts/TableLayout";
import { customPricingOutbound } from "../OutboundSlider";
import { Alert } from "antd";

function pricePerThousandMessages(plan) {
    let f = plan.features.find(f => f.handle.startsWith("messages-submitted-"));

    return f && f.pricing.prices[0].pricePerUnit;
}

const OutboundPlanComparison = props => {
    const { plans } = props;

    const data = [
        {
            key: "1",
            name: "Included Emails",
            ...plans.reduce((acc, plan) => {
                acc[plan.planName] = friendlyNumber(plan.includedEmails);
                return acc;
            }, {}),
        },
        {
            key: "2",
            name: "Base Price",
            ...plans.reduce((acc, plan) => {
                acc[plan.planName] = friendlyPrice(plan.basePrice);
                return acc;
            }, {}),
        },
        {
            key: "3",
            name: "Price per 1,000 extra emails",
            ...plans.reduce((acc, plan) => {
                acc[plan.planName] = friendlyPrice(pricePerThousandMessages(plan));
                return acc;
            }, {}),
        },
    ];

    const columns = [
        {
            title: "",
            dataIndex: "name",
            key: "name",
            render: text => <span style={{ fontSize: "0.75rem" }}>{text}</span>,
        },
        ...plans.map(plan => ({
            title: plan.planName,
            dataIndex: plan.planName,
            key: plan.planName,
            align: "right",
        })),
    ];

    return (
        <div style={{ padding: "0 0.75rem" }}>
            <TableLayout dataSource={data} columns={columns} />
            <Alert message={customPricingOutbound} type="info" style={{ marginTop: "1.5rem" }} />
        </div>
    );
};

export default OutboundPlanComparison;
